import { render, staticRenderFns } from "./FavorBtns.vue?vue&type=template&id=42b8ff66&scoped=true&"
import script from "./FavorBtns.vue?vue&type=script&lang=js&"
export * from "./FavorBtns.vue?vue&type=script&lang=js&"
import style0 from "./FavorBtns.vue?vue&type=style&index=0&id=42b8ff66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8ff66",
  null
  
)

export default component.exports